"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Pass key-value pairs, if value is true
 * then returned string will contain key
 *
 * @example
 * classesString({'active': false, 'disabled': true, 'wk-list': true})
 * => 'disabled wk-list'
 */
function classesString(dict) {
    return Object.keys(dict)
        .filter(function (key) { return dict[key] !== false; })
        .join(' ');
}
exports.classesString = classesString;
